import App from 'app/app.js';

// Simple implementation for dispatcher poc using $rootScope
function EventService($rootScope) {
  /**
   * Dispatch an event to listeners
   * @param {String} event name
   * @param {Object} args
   */
  this.dispatch = function (event, args) {
    $rootScope.$emit(event, args);
  };

  /**
   * Register an event listener
   * @param {String} event
   * @param listener
   * @returns {function()} Function to remove the listener
   */
  this.register = function (event, listener) {
    return $rootScope.$on(event, listener);
  };
}

App.service('EventService', ['$rootScope', EventService]);
